import React, { lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/Store";
import { getUserData } from "./components/login/LoginSlice";
import AppWrapper from "./App";
import { SelectedYearProvider } from "./Context/SelectYearContext";
import PrivateRoute from "./Root/PrivateRoot";
import Login from "./components/login/Login";
import ResetPassword from "./components/login/ForgetPass";
import AdminLayout from "./components/Layout/Layout";
import MyAccount from "./components/MyAccount/MyAccount";
import EsclationMatrix from "./components/EscalationMatrix/EsclationMatrix";
import PolicyFeatures from "./components/Policy/PolicyFeatures";
import Document from "./components/Document/Index";
import Claims from "./components/Claims/index";
import IntimateClaim from "./components/Claims/IntimateClaims";
import CdEndorList from "./components/CdEndorsment";
import CashlessData from "./components/CashlessHospital";
import Enrollment from "./components/Enrolment/index";
import Reports from "./components/Reports/index";
import EmployeActivity from "./components/Employe/EmployeActivity";
import Summary from "./components/Summary/Summary";
import RiskLocation from "./components/RiskLocation/RiskLocation";
import RackRateList from "./components/Endorsement/RackRate/RackList";
import EndorseList from "./components/Endorsement/EndorseCal";
import EndorseCalc from "./components/Endorsement/EndorseCal/EndorseCalc";
import EndorseRackRatePolicyList from "./components/Endorsement/RackRate";
import AddRackRate from "./components/Endorsement/RackRate/AddRackRate";
import Endorsement from "./components/Endorsement/index";
import EndorseView from "./components/Endorsement/EndorseCal/ViewEndorsement";

const PortalDashboard = lazy(() =>
  import("./components/PortalDashboard/PortalDashboard")
);
function AppRoutes() {
  const AuthData = useSelector(getUserData);
  console.log("AuthData", AuthData);
  return (
    <Router>
      <AppWrapper>
        <SelectedYearProvider>
          <Routes>
            <Route
              path="/"
              element={
                AuthData ? (
                  <Navigate to="/corporate/Dashboard" />
                ) : (
                  <Login />
                )
              }
            />
            <Route path="/ResetPassword" element={<ResetPassword />} />
            <Route path="/corporate" element={<PrivateRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="Dashboard" element={<PortalDashboard />} />
                <Route path="RiskLocation" element={<RiskLocation />} />
                <Route path="EscalationMatrix" element={<EsclationMatrix />} />
                <Route path="PolicyFeatures" element={<PolicyFeatures />} />
                <Route path="Document" element={<Document />} />
                <Route path="Claims" element={<Claims />} />
                <Route path="IntimateClaims" element={<IntimateClaim />} />
                <Route path="Enrollment" element={<Enrollment />} />
                <Route path="endorsement_list" element={<CdEndorList />} />
                <Route path="cashless_hospitals" element={<CashlessData />} />
                <Route path="MyAccount" element={<MyAccount />} />
                <Route path="EmployeActivity" element={<EmployeActivity />} />
                <Route path="Reports" element={<Reports />} />
                <Route path="Summary" element={<Summary />} />
                <Route path="add_rackrates" element={<AddRackRate />} />
                <Route
                  path="rackrate_list"
                  element={<EndorseRackRatePolicyList />}
                />
                <Route path="rackrate" element={<RackRateList />} />
                <Route
                  path="endorsement_calculation"
                  element={<EndorseCalc />}
                />
                <Route path="endorsement" element={<Endorsement />} />
                <Route path="endorsement_list" element={<EndorseList />} />
                <Route path="endorsement_view" element={<EndorseView />} />
              </Route>
            </Route>
          </Routes>
        </SelectedYearProvider>
      </AppWrapper>
    </Router>
  );
}

function Root() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppRoutes />
      </PersistGate>
    </Provider>
  );
}
export default Root;
